<template>
  <div class="cr-order">
    <div class="cr-container">
      <div v-if="orderLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="orderError" class="mc-form__message mc-form__message--alert" v-html="orderError"></div>
      <form v-if="isAuth && orderLoaded && order.quantity > 0" @submit.prevent="handleSubmit" class="cr-order__form cr-form" method="post" autocomplete="off">

        <div v-if="formErrors.length > 0" class="cr-detail-card__message cr-message cr-message--error">
          <div>
          <div v-for="error in formErrors"
               :key="error.field"
               :ref="`${error.field}Error`">
            {{ error.message }}
          </div>
          </div>
        </div>

        <fieldset class="cr-form__fieldset">
          <div class="cr-form__field">
                            <span class="cr-form__label">
                                Контрагент
                                <span class="cr-form__asterisk">
                                    *
                                </span>
                            </span>
            <div class="cr-dropdown" :class="{ 'isOpen': activeDropdown === 'user' }">
              <button @click="toggleDropdown($event, 'user')"
              class="cr-dropdown__button js-button-dropdown" type="button">
                                    <span class="cr-dropdown__select-main">
                                        {{ selectedUser ? selectedUser.name : 'Выберите пользователя' }}

                                    </span>
              </button>
              <div class="cr-dropdown__body"
              >
                <ul class="cr-dropdown__list">
                  <li v-for="item in order.user" :key="item.id"
                      class="cr-dropdown__item">
                    <button @click="selectUser(item)"
                            class="cr-dropdown__item-button js-select-button" type="button">
                                                <span class="cr-dropdown__select-main">
                                                    {{ item.name }}
                                                </span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="cr-form__field">
                            <span class="cr-form__label">
                                Адрес отгрузки
                                <span class="cr-form__asterisk">
                                    *
                                </span>
                            </span>
            <div class="cr-dropdown" :class="{ 'isOpen': activeDropdown === 'address' }">
              <button @click="toggleDropdown($event, 'address')"
                      class="cr-dropdown__button js-button-dropdown" type="button">
                                     <span class="cr-dropdown__select-main">
          {{ selectedAddress ? selectedAddress.name : 'Выберите адрес' }}
        </span>

                <span v-if="selectedAddress" class="cr-dropdown__select-second">
          {{ selectedAddress.address }}
        </span>

              </button>
              <div v-if="selectedUser && order.address[selectedUser.id]" class="cr-dropdown__body" >
                <ul class="cr-dropdown__list">
                  <li v-for="address in order.address[selectedUser.id]"
                      :key="address.id"
                      class="cr-dropdown__item">
                    <button @click="selectAddress(address)"
                            class="cr-dropdown__item-button js-select-button" type="button">
                                                <span class="cr-dropdown__select-main">
                                                  {{ address.name }}

                                                </span>
                      <span class="cr-dropdown__select-second">
                                                   {{ address.address }}

                                                </span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="cr-form__field">
            <label class="cr-form__label" for="comment">
              Комментарий
            </label>
            <textarea v-model="comment" class="cr-form__textarea" name="comment" id="comment" rows="2" placeholder="Укажите желаемое время доставки и ваш комментарий"></textarea>
          </div>
        </fieldset>
        <div class="cr-form__bottom">
          <div class="cr-summary">
            <dl class="cr-summary__list">
              <div class="cr-summary__item cr-summary__item--strong">
                <dt class="cr-summary__term">
                  Итого
                </dt>
                <dd class="cr-summary__value">
                  {{ formatPrice(order.price) }} ₽
                </dd>
              </div>
              <div v-if="order.discount > 0" class="cr-summary__item">
                <dt class="cr-summary__term">
                  Итого без скидки
                </dt>
                <dd class="cr-summary__value">
                  {{ order.full_price }} ₽
                </dd>
              </div>
              <div v-if="order.discount > 0" class="cr-summary__item">
                <dt class="cr-summary__term">
                  Скидка
                </dt>
                <dd class="cr-summary__value">
                  {{ formatPrice(order.discount) }} ₽
                </dd>
              </div>
              <div class="cr-summary__item">
                <dt class="cr-summary__term">
                  Наименований
                </dt>
                <dd class="cr-summary__value">
                  {{ order.quantity }}
                </dd>
              </div>
            </dl>
            <div class="cr-summary__bottom">
              <button class="cr-button" type="submit">
                                    <span class="cr-button__text">
                                        Заказать
                                    </span>
              </button>
            </div>
          </div>
        </div>
      </form>
      <div v-if="!isAuth && orderLoaded">
        <p>Для ооформления заказа авторизуйтесь</p>
        <router-link to="/catalog/" class="mc-outfit__cta-button mc-button simulated-hover">Перейти в каталог</router-link>
      </div>
      <div v-else-if="orderLoaded && order.quantity == 0">
        <p>Для ооформления заказа добавьте товары в корзину</p>
        <router-link to="/catalog/" class="mc-outfit__cta-button mc-button simulated-hover">Перейти в каталог</router-link>
      </div>
    </div>
  </div>


</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash';
import axios from 'axios';
import product from "@/mixin/product.vue";

export default {
  data: () => ({
    activeDropdown: null,
    selectedUser: null,
    selectedAddress: null,
    comment: '',
    formErrors: []
  }),
  mixins: [product],
  watch: {
    success(newValue, oldValue) {
      if (newValue == 'Y')
        this.$router.push(this.redirect.replace("/api/order/", "/order/success/"))
    }
  },
  async created() {
    await this.fetchOrder();
    if (this.order.user && this.order.user.length > 0) {
      this.selectedUser = this.order.user[0];
    }
  },
  mounted() {
    // Добавляем слушатель для закрытия дропдауна при клике вне его
    document.addEventListener('click', this.closeDropdownOnClickOutside);
  },

  beforeUnmount() {
    // Удаляем слушатель при уничтожении компонента
    document.removeEventListener('click', this.closeDropdownOnClickOutside);
  },
  computed: {
    ...mapGetters('order', [
      'order',
      'orderLoading',
      'orderError',
      'orderLoaded',
      'success',
      'redirect',
    ]),
    ...mapGetters([
      'isAuth',
    ]),
  },
  components: {/*MaskInput*/},
  methods: {
    ...mapActions('order', [
      'fetchOrder',
      'reloadOrder',
        'saveOrder'
    ]),

    toggleDropdown(event, dropdownName) {
      event.stopPropagation();
      this.activeDropdown = this.activeDropdown === dropdownName ? null : dropdownName;
    },

    selectUser(user) {
      this.selectedUser = user;
      this.activeDropdown = null;
      // Здесь можно добавить дополнительную логику, например:
      // this.$emit('user-selected', user);
    },

    selectAddress(address) {
      this.selectedAddress = address;
      this.activeDropdown = null;
      // Здесь можно добавить дополнительную логику, например:
      // this.$emit('address-selected', address);
    },

    closeDropdownOnClickOutside(event) {
      if (!event.target.closest('.cr-dropdown')) {
        this.activeDropdown = null;
      }
    },
    validateForm() {
      this.formErrors = []; // Очищаем массив ошибок

      if (!this.selectedUser) {
        this.formErrors.push({
          field: 'user',
          message: 'Пожалуйста, выберите контрагента'
        });
      }

      if (!this.selectedAddress) {
        this.formErrors.push({
          field: 'address',
          message: 'Пожалуйста, выберите адрес отгрузки'
        });
      }

      return this.formErrors.length === 0;
    },


    // Скролл к первой ошибке
    scrollToError() {
      if (this.formErrors.length > 0) {
        const firstErrorRef = `${this.formErrors[0].field}Error`;
        if (this.$refs[firstErrorRef]?.[0]) {
          this.$refs[firstErrorRef][0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    },

    async handleSubmit() {
      this.formErrors = [];
      if (!this.validateForm()) {
        this.scrollToError();
        return;
      }

      try {
        const data = {
          user_id: this.selectedUser.id,
          address_id: this.selectedAddress.id,
          comment: this.comment
        };

        const result = await this.saveOrder(data);

        if (result !== true) {
          this.formErrors = result;
          this.$nextTick(() => {
            const errorElement = this.$el.querySelector('.cr-message--error');
            if (errorElement) {
              errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
        }
        else {
          this.$router.push("/order/success/?id="+this.success.id);
        }

        // Если нет ошибок после сохранения, редирект произойдет автоматически
        // благодаря watch-обработчику success

      } catch (error) {
        // Если пришла ошибка с сервера, покажем её и прокрутим к ней
        this.formErrors.push({
          field: 'code',
          message: error.response?.data?.message || 'Произошла ошибка при отправке формы'
          });

        this.$nextTick(() => {
          const errorElement = this.$el.querySelector('.cr-message--error');
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    },


  },
}
</script>

